import React, { PureComponent } from 'react';
import { status } from '../propTypes';

import { Tag } from '@ontruck/orc';
import { TableCellStyled } from './styled';

const statusMap = {
  PENDING_CONFIRMATION: 'In queue',
  PENDING_MODERATION: 'In queue',
  PENDING_ASSIGNMENT: 'In queue',
  ASSIGNED: 'Assigned',
  IN_TRANSIT: 'In transit',
  DONE: 'Finished',
  CANCELLED: 'Cancelled',
};

class TableCellStatus extends PureComponent {
  render() {
    const { status } = this.props;

    return (
      <TableCellStyled>
        <Tag text={statusMap[status]} size="M" />
      </TableCellStyled>
    );
  }
}

TableCellStatus.propTypes = {
  status,
};

TableCellStatus.defaultProps = {
  status: null,
};

export default TableCellStatus;
